import React from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
  return (
    <>
      <nav className="navbar navbar-expand-lg bg-light">
        <div className="container">
          {/* Logo */}
          <Link className="navbar-brand" to="/">
            <img src="/project/images/logo.png" alt="Logo" height="40" />
          </Link>

          {/* Hamburger Button for Offcanvas */}
          <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#mobileMenu" aria-controls="mobileMenu">
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Desktop Menu */}
          <div className="collapse navbar-collapse justify-content-end desktop-menu">
            <ul className="navbar-nav mb-2 mb-lg-0">
              <li className="nav-item">
                <Link className="nav-link" to="/">Home</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/About">About</Link>
              </li>
             {/* Dropdown */}
            <li className="nav-item dropdown">
              <span className="nav-link">Locations</span>
              <ul className="sub-menu">
                <li>
                  <Link className="nav-link" to="/Auckland">Auckland</Link>
                </li>
                
               
              </ul>
            </li>

 <li>
                  <Link className="nav-link" to="/blog">blog</Link>
                </li>
              <li className="nav-item">
                <Link className="nav-link" to="/Service">Service</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/Contact">Contact</Link>
              </li>
            </ul>

            {/* Social Icons */}
            <div className="navbar-icon ms-3">
              <i className="fa-brands fa-facebook me-2"></i>
              <i className="fa-brands fa-x-twitter me-2"></i>
              <i className="fa-brands fa-instagram me-2"></i>
              <i className="fa-brands fa-linkedin"></i>
            </div>
          </div>
        </div>
      </nav>

      {/* Offcanvas Mobile Menu */}
      <div className="offcanvas offcanvas-end" tabIndex="-1" id="mobileMenu" aria-labelledby="mobileMenuLabel">
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="mobileMenuLabel">Menu</h5>
          <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div className="offcanvas-body">
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link className="nav-link" to="/" data-bs-dismiss="offcanvas">Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/About" data-bs-dismiss="offcanvas">About</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/Auckland" data-bs-dismiss="offcanvas">Auckland</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/Service" data-bs-dismiss="offcanvas">Service</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/Contact" data-bs-dismiss="offcanvas">Contact</Link>
            </li>
          </ul>

          {/* Social Icons */}
          <div className="mt-3">
            <i className="fa-brands fa-facebook me-2"></i>
            <i className="fa-brands fa-x-twitter me-2"></i>
            <i className="fa-brands fa-instagram me-2"></i>
            <i className="fa-brands fa-linkedin"></i>
          </div>
        </div>
      </div>
    </>
  );
}

export default Navbar;
